import NoSsr from '@eversports/klimt-design-components/NoSsr'
import Box from '@eversports/klimt-primitives/legacy/Box'
import Link from '@eversports/klimt-primitives/legacy/Link'
import Stack from '@eversports/klimt-primitives/legacy/Stack'
import Text from '@eversports/klimt-primitives/legacy/Text'

import { RECAP_YEAR } from '../../App.constants'
import { useYearlyRecapBannerMeQuery } from '../../graphql'
import { Localized } from '../../localization/react'

import FacePartySVG from './assets/face-party.svg'
import BackgroundImage from './assets/recap-background-image.webp'

const YearlyRecapBanner = () => {
  const { data } = useYearlyRecapBannerMeQuery({ variables: { year: Number(RECAP_YEAR) } })

  if (!data || !data.me || !data.me.recapToken) {
    return null
  }

  return (
    <Link to={`/user/${data.me.recapToken}/yearly-recap`}>
      <Box
        sx={{
          backgroundImage: `url(${BackgroundImage})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundColor: 'white',
          padding: 3,
          textAlign: 'center',
          width: '100%',
          borderBottom: '1px solid',
          borderColor: 'primary.main',
          position: 'sticky',
          zIndex: 6,
        }}
      >
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          gap={{ xs: 0, sm: 2 }}
          alignItems="center"
          justifyContent="center"
        >
          <Stack direction="row" gap={2} alignItems="center">
            <Box
              sx={{
                padding: 1,
                borderRadius: 1,
                background:
                  'linear-gradient(0deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.60) 100%), #D3EDEA',
              }}
            >
              <img src={FacePartySVG} height="20px" width="20px" />
            </Box>
            <Text variant="large" sx={{ color: 'midnight', fontWeight: 'bold' }}>
              <Localized id="yearly-recap-banner-title" params={{ year: RECAP_YEAR }} />
            </Text>
          </Stack>
          <Text>
            <Localized id="yearly-recap-banner-subtitle" />
          </Text>
        </Stack>
      </Box>
    </Link>
  )
}

const YearlyRecapBannerWrapper = () => {
  return (
    <NoSsr>
      <YearlyRecapBanner />
    </NoSsr>
  )
}

export default YearlyRecapBannerWrapper
